import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/minimal/pause.js
const PauseIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [/* @__PURE__ */ jsx("rect", {
		width: 4,
		height: 12,
		x: 3,
		y: 3,
		rx: 1.75
	}), /* @__PURE__ */ jsx("rect", {
		width: 4,
		height: 12,
		x: 11,
		y: 3,
		rx: 1.75
	})]
});
const ForwardRef = forwardRef(PauseIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=pause.js.map